<script setup lang="ts">
import { computed, useSlots } from 'vue';
import { gaiaNeutral } from '../../themes/tokens';

const props = defineProps({
  /** Show the #document column. Off leaves the field column on its own. */
  showDocument: {
    type: Boolean,
    default: true,
  },
});

const slots = useSlots();
const hasMain = computed(() => props.showDocument && Boolean(slots.document));

const surface = gaiaNeutral.surface;
const divider = gaiaNeutral.borderDivider;
</script>

<template>
  <!-- An intake file in the History pane: the #document column
       edge to edge, so the preview lines up with the list and the field column
       beside it, and that column headed by #header (the file name and its
       pager), scrolling on its own over a pinned #footer. -->
  <div class="gaia-intake-detail">
    <div v-if="hasMain" class="document">
      <slot name="document" />
    </div>
    <div v-if="$slots.default" class="fields-column">
      <div v-if="$slots.header" class="header"><slot name="header" /></div>
      <div class="fields">
        <slot />
      </div>
      <div v-if="$slots.footer" class="footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.gaia-intake-detail {
  flex: 1;
  min-height: 0;
  display: flex;
  background: v-bind(surface);
}

.header {
  flex: none;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 52px;
  padding: 0 22px;
  border-bottom: 1px solid v-bind(divider);
}

.document {
  flex: 1 1 420px;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.fields-column {
  flex: 1 1 380px;
  max-width: 420px;
  min-width: 280px;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border-left: 1px solid v-bind(divider);
}

/* On its own the field column takes the pane rather than floating in it. */
.gaia-intake-detail > .fields-column:only-child {
  max-width: none;
  border-left: none;
}

.fields {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 18px 22px;
}

.footer {
  flex: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 22px;
  border-top: 1px solid v-bind(divider);
}
</style>
